import React from 'react';
import Page from '../../../components/Page';
import Panel from '../../../components/Panel';

export default function TermsAndConditions (props) {
    return (
        <Page title="Terms And Conditions">
            <div className='row'>
                <div className='col-12'>
                    <Panel
                        panelStyle={{ marginTop: 40 }}
                        headerStyle={{ display: 'none' }}
                        contentStyle={{ marginTop: 24 }}
                    >
                        By accessing and using the Web Sites, you acknowledge that you have read and agree to these Terms and Conditions. If you do not agree to be bound by these Terms, please immediately exit and cease accessing and using the Web Site.

                        These terms of use (also referred to as “Terms”) are intended to set forth the basic terms and conditions governing the services described below between you and Carbon Solutions Group, llc., and/or its various affiliates and subsidiaries (collectively referred to as “CSG”).

                    </Panel>

                    <Panel
                        title="Links"
                    >
                        We may provide links to other outside web sites. Carbon Solutions Group is not responsible for such linked web sites or the contents of any of the linked web sites. We provide links to the linked web sites as an additional resource for our web sites' users and make no representations regarding the contents of any linked web sites or any persons or companies that own, control or manage the linked web sites. Consequently, we are not responsible for the accuracy, relevancy, copyright compliance, legality or material contained in, programs used by, or services or products offered by the linked web sites. If you access any of the linked web sites, you do so entirely at your own risk and subject to the terms and conditions of use for such linked web sites.
                    </Panel>

                    <Panel
                        title="Limitation Of Liability"
                    >
                        In no event shall carbon solutions group or our subsidiaries, or any of our respective licensors, service providers, employees, agents, officers or directors, be liable for damages of any kind, under any legal theory, arising out of or in connection with your use or access, or inability to use or access, the web sites, or any linked websites, including, without limitation, any direct, indirect, incidental, special, or consequential or punitive damages that result from the same, even if we have been advised of the possibility of such damages. We are not responsible for technical, hardware or software failures or losses of any kind. In no event will we or our subsidiaries, or any of our respective licensors, service providers, employees, agents, officers or directors total liability to you for all damages, losses, and causes of action, whether in contract, tort, or otherwise, exceed the amount paid by you, if any, for accessing the web sites. The included does not affect any liability which cannot be excluded or limited under applicable law.
                    </Panel>

                    <Panel
                        title="Indemnification"
                    >
                        You agree to defend, indemnify and hold harmless “CSG” and our subsidiaries, and any of our respective directors, officers, employees and agents from and against all claims and expenses, including attorneys' fees, arising out of your use of the Web Sites or violation of these Terms.    
                    </Panel>

                    <Panel
                        title="Trademarks"
                    >
                        The trademarks, service marks, and logos (collectively, “Trademarks”) used and displayed on this website are registered and unregistered marks of Carbon Solutions Group and others.
                    </Panel>

                    <Panel
                        title="Modifications"
                    >
                        Carbon Solutions Group reserves the right to modify the information contained on this website or these Terms at any time without notice. 
                    </Panel>

                    <Panel
                        title="Third Party Websites"
                    >
                        Carbon Solutions Group may provide a link to a Third-Party Site, such a link is not an authorization, endorsement, sponsorship or affiliation by CSG with respect to such Third-Party Site, its content, its owners or its providers. Accordingly, CSG makes no representations whatsoever concerning such ThirdParty Sites. You are solely responsible for determining the extent to which you may use any content at any other Third-Party Sites to which you link from the Service.                    
                    </Panel>

                    <Panel
                        title="Restriction, Suspension and Termination"
                    >
                        Carbon Solutions Group may restrict, suspend or terminate your access to the Site and/or your ability to access any of the services on the Site, including interactive services, if we believe that you have breached these Terms at any time.                  
                    </Panel>

                </div>
            </div>
        </Page>
    );
};